<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px; padding-top: 40px; padding-bottom: 100px"
        class="term_service"
      >
        <h1>Use of Cookies and Internet Tracking</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <h2>Cookies</h2>
        <p>
          Cookies are small text files that are placed on your computer’s hard
          drive or onto your mobile device’s memory -- if your browser is set to
          accept cookies. Like many other online services, cookies and other
          tools like them help us collect and understand how you use our
          services.
        </p>
        <p>
          Although most internet browsers automatically accept cookies, you can
          change your settings or use third-party tools to prompt you before
          accepting cookies from the websites you choose to visit, or to refuse
          cookies altogether. You can even delete them through your browser.
          Most browsers also have settings to prevent them from accepting new
          cookies, to notify you when you receive a new cookie, or to delete or
          disable cookies altogether. Some parts of our Services may not work
          for you if you disable cookies.
        </p>
        <h2>How We Use Cookies</h2>
        <p>
          We use cookie technology in various ways to help make it easier for
          you to use our Services. For example, we use cookies to remember you
          when you return to our website, identify you when you sign-in,
          authenticate your access, keep track of your in-app specified
          preferences or choices, tailor content to you or geographic region,
          display a personalized browsing history, and/or to provide specific
          technical support.
        </p>
        <p>
          We may also use cookies to gauge site usage, conduct research and
          diagnostics to improve the content we provide you, our products and
          services, and to help us analyze general web traffic.
        </p>
        <p>
          The cookies we use expire after they have fulfilled their purpose.
          Some cookies expire when you close your browser (i.e., session
          cookies) or after a set period of time (i.e., persistent cookies). The
          expiration time of cookies that are placed by third parties (explained
          below) is determined by the third-party, not us.
        </p>

        <h2>Web Beacons</h2>
        <p>
          Web beacons (also known as web bugs, pixel tags or clear GIFs) are
          tiny graphics with a unique identifier that may be included on our
          Services for several purposes, including to deliver or communicate
          with cookies, to track and measure the performance of our Services, to
          monitor how many visitors view our Services, and to monitor the
          effectiveness of our advertising. Unlike cookies, which are stored on
          the user’s hard drive, web beacons are typically embedded invisibly on
          web pages (or in an e-mail).
        </p>
        <h2>Do Not Track</h2>
        <p>
          While our website and the Truthbrush app at this time do not recognize
          automated browser signals regarding tracking mechanisms, such as "do
          not track" instructions, you can generally express your privacy
          preferences regarding the use of most cookies and similar technologies
          through your web browser, as indicated above.
        </p>

        <h2>Web Analysis Services</h2>
        <p>
          We may use third-party web analysis services which use cookies or
          other web technologies to collect usage information, matched to an IP
          address, to help us analyze how our users use our website and some
          portions of the Truthbrush app. We collect this information in order
          to improve overall experience of our Services for our users.
        </p>

        <p>
          We utilize Google Analytics, a service provided by Google, Inc. to
          gather information about how users and visitors engage with our Site
          and Services. For more information about Google Analytics, please
          visit www.google.com/policies/privacy/partners. </p>

        <p>
          These outside services may also collect information about your use of
          other websites over time. Since we do not link any information that
          you provide to us within the app to the information we store within
          the third-party analytics software, this additional information is
          stored in a way that does not directly identify you.
        </p>

        <h2>Social Plugins and Social Widgets</h2>
        <p>
          We may use social plugins, widgets and other features (each, a “Social
          Feature”) that are made available by and/or access third-party Social
          Networks. These Social Features allow these Social Networks to place
          cookies on your browser and to collect certain information, which may
          be associated with your name and personal Social Network account.
        </p>

        <p>
          These Social Features are operated solely by the respective Social
          Networks, and their service providers, and we recommend that you
          carefully read their privacy policies before you decide to use them.
          We have no control over or access to the information collected, stored
          or used by such Social Networks, and the information practices of such
          Social Networks are not covered by this Privacy Policy.
        </p>

        <p>
          If you do not wish to associate any information collected via the
          plugins, widgets and/or other features with your personal Social
          Network account information, you should refrain from using these
          Social Features and logout from your Social Network account before
          visiting our Services.
        </p>

        <h2>Third-Party Payment Processing</h2>
        <p>
          When you purchase Truthbrush products, we process your payments
          through a third-party application, including the Apple App Store,
          Google Play App Store, Amazon App Store (together with any similar
          applications, “App Stores”) and Social Networks such as Facebook. The
          third-party application may collect certain financial information from
          you to process a payment on behalf of Truthbrush, including your name,
          email address, address and other billing information.
        </p>
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
  },
};
</script>

<style lang="scss">
.term_service h2 {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .term_service h2,
  .term_service h4 {
    text-align: center;
  }
}
</style>